module.exports = __webpack_public_path__ + "static/media/fleetCompanies.1fd1fa32.svg";